import { useEffect } from "react";

type Props = {
  show: boolean;
  setShow: any;
  Form?: any;
  formData?: any;
  reload?: any;
};
const NewModal = ({ show, setShow, Form, formData, reload }: Props) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      className={`flex items-center justify-center fixed left-0 top-0 right-0 bottom-0 z-10`}
      style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
    >
      <Form setShow={setShow} formData={formData} reload={reload} />
    </div>
  );
};

export default NewModal;
